import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ComposerPopover from '~/composer-popover';
import { BufferLoading } from '~/shared-components';

import formatPostFromQuery from './formatPostFromQuery';

const StyledLoader = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  height: inherit;
  align-items: center;
`;

const ComposePage = ({
  onComposerCreateSuccess,
  onConfirmDismissComposer,
  initComposer,
  queryParams,
  isLoading,
}) => {
  useEffect(() => {
    const post = formatPostFromQuery(queryParams);
    initComposer({
      shouldResetComposerData: true,
      post,
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <StyledLoader>
          <BufferLoading size={64} />
        </StyledLoader>
      ) : (
        <ComposerPopover
          onSave={onComposerCreateSuccess}
          onConfirmDismissComposer={onConfirmDismissComposer}
          type="composerPopover"
        />
      )}
    </>
  );
};

ComposePage.propTypes = {
  queryParams: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  initComposer: PropTypes.func.isRequired,
  onComposerCreateSuccess: PropTypes.func.isRequired,
  onConfirmDismissComposer: PropTypes.func.isRequired,
};

ComposePage.defaultProps = {
  queryParams: '',
};

export default ComposePage;
